import { useEffect, useRef } from "react";
import { Sparkles } from "lucide-react";

export const VelocityMarquee = ({ items, dark = false }) => {
  const innerRef = useRef(null);
  const pos = useRef(0);
  const vel = useRef(0);
  const dir = useRef(1);
  const lastY = useRef(0);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    lastY.current = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      const d = y - lastY.current;
      vel.current += d;
      if (Math.abs(d) > 0.5) dir.current = d > 0 ? 1 : -1;
      lastY.current = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    let raf;
    const tick = () => {
      vel.current *= 0.9;
      const el = innerRef.current;
      if (el) {
        const half = el.scrollWidth / 2 || 1;
        pos.current -= dir.current * (1.1 + Math.min(Math.abs(vel.current) * 0.12, 9));
        if (pos.current <= -half) pos.current += half;
        if (pos.current > 0) pos.current -= half;
        el.style.transform = `translate3d(${pos.current}px,0,0)`;
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const list = items && items.length ? items : ["Royal Skin"];
  const row = [...list, ...list, ...list];

  return (
    <div
      className="overflow-hidden border-y py-6"
      style={{ borderColor: dark ? "var(--imm-line, rgba(255,255,255,0.1))" : "rgba(26,26,26,0.1)" }}
      data-testid="velocity-marquee"
      aria-hidden="true"
    >
      <div ref={innerRef} className="flex w-max items-center will-change-transform">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span
              className="whitespace-nowrap font-display text-3xl italic sm:text-4xl"
              style={{ color: dark ? "var(--imm-text, rgba(245,239,230,0.85))" : "rgba(26,26,26,0.85)" }}
            >
              {t}
            </span>
            <Sparkles className="mx-10 h-4 w-4 shrink-0 text-[#D4AF37]" />
          </span>
        ))}
      </div>
    </div>
  );
};
